import React from 'react';

import { defaultInitialsFieldHeightPx, defaultInitialsFieldWidthPx } from '@aline/common';
import { useSelectCurrentUser } from 'src/gql';
import { useRefreshableFilestackImg } from 'src/helpers/integrations/filestack-download';
import type { ReactSetStateAction } from 'src/types';

interface DrawInitialsPreviewProps {
  isDrawInitialsEmpty: boolean;
  setDrawInitialsPreviewCanvas: ReactSetStateAction<HTMLCanvasElement | null>;
}

export function DrawInitialsPreview({
  isDrawInitialsEmpty,
  setDrawInitialsPreviewCanvas,
}: DrawInitialsPreviewProps): JSX.Element {
  const currentUser = useSelectCurrentUser();
  const { onError, src } = useRefreshableFilestackImg(currentUser?.settings.signatureInitialsImg);

  if (isDrawInitialsEmpty && src)
    return (
      <div
        style={{
          height: defaultInitialsFieldHeightPx,
          overflow: 'visible',
          position: 'relative',
          width: defaultInitialsFieldWidthPx,
        }}
      >
        <img
          alt="signature-initials"
          height={defaultInitialsFieldHeightPx}
          src={src}
          width={defaultInitialsFieldWidthPx}
          onError={onError}
        />
      </div>
    );

  return (
    <div
      style={{
        height: defaultInitialsFieldHeightPx,
        overflow: 'visible',
        position: 'relative',
        width: defaultInitialsFieldWidthPx,
      }}
    >
      <canvas
        ref={setDrawInitialsPreviewCanvas}
        height={defaultInitialsFieldHeightPx}
        width={defaultInitialsFieldWidthPx}
      />
    </div>
  );
}
